import React from 'react'

import quickAdd_createLink from "../../../../../app/quick-add/sections/structure/link/helpers/create-link"
import NavigationMenuItemInputCommon from "./menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../core/gd/const/project"

type Props = {
    level?      : number
    parentId?   : ID

    onAdded     : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddLink"
const debug = false

export default function NavigationMenuItemAddLink(props: Props) {

    const projectIcon = 'link'

    const onCommit = async (value?:string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        const project = await quickAdd_createLink({
            parentProject   : props.parentId,
            name            : value,
            owner           : gd.user.id,
            color           : gd.session.projects.get(props.parentId)?.color,
        })

        gd.goTo(project!.url + '/link/edit')
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[projectIcon]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}